import { Component, Inject, OnInit } from '@angular/core';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { serviceUrl } from '../common/serviceconstants';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-projectdocmodelpopup',
  templateUrl: './projectdocmodelpopup.component.html',
  styleUrls: ['./projectdocmodelpopup.component.scss']
})
export class ProjectdocmodelpopupComponent implements OnInit {
  id: any;
  isadmin: any = false;


  constructor(private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.id = data.message.ID;
    let a = sessionStorage.getItem("Admin");
    if (a && a === "True") {
      this.isadmin = true;
    }
  }
  ngOnInit(): void {
    this.getprojectdocumentallinfo();
  }



  displayedColumns: string[] =
    [
      'DocumentName',
      'FileName',
      'DocumentAuthor',
      'PublicAccess',
      'View'
    ];

  cDocsData: any = [];
  cdocsvisible: any = false;
  DocsdataSource: any = [];
  docmessage: any = '';

  getprojectdocumentallinfo() {
    this.http.get(serviceUrl + '/ProjectDocuments/GetProjectDocs',
      { params: { projnumber: this.id, isadmin: this.isadmin } }).toPromise<any>().then(response => {
        this.cDocsData = response;
        this.DocsdataSource = new MatTableDataSource(response);
        if (this.cDocsData.length > 0) {
          this.cdocsvisible = true;

        } else {
          this.docmessage = "This Project has no documents at this time."
        }
      });
  }

  downloadfile(item) {
    // this.loaderService.display(true);
    const url = serviceUrl + '/jobsforjaxdocs/' + item.FileName;
    window.open(url, '_blank');
  }

}
